import React from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

function Toolbar({
  handleSearch,
  handleChangeTrainingProvider,
  onPageSizeChange,
  trainingProviders,
  defaultValue,
  t
}) {
  return (
    <div className="dt-toolbar" style={{ padding: `1em` }}>
      <div className="col-xs-12 col-lg-2 col-md-3 col-sm-4">
        <div id="dt_basic_filter" className="dataTables_filter">
          <label>
            <span className="input-group-addon">
              <i className="glyphicon glyphicon-search" />
            </span>
            <input
              aria-controls="dt_basic"
              className="form-control"
              onChange={handleSearch}
              placeholder=""
              type="search"
            />
          </label>
        </div>
      </div>

      <div className="col-xs-12 col-md-4 col-sm-5" style={{ padding: 0 }}>
        <label style={{ marginRight: 10 }}>
          {t(`modules.localization.register.authenticated.usersList.trainingProvider`, {
            count: 0
          })}
        </label>
        <select
          onChange={handleChangeTrainingProvider}
          className="form-control"
          id="select-1"
          value={defaultValue}
          style={{ width: 120 }}
        >
          <option value="all" key="0">
            {t(`modules.localization.register.authenticated.usersList.all`)}
          </option>
          {trainingProviders.map((option, index) => (
            <option key={index + 1} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <div className="col-sm-3 col-xs-12 hidden-xs pull-right">
        <div className="dataTables_length" id="dt_basic_length">
          <label>
            <select
              aria-controls="dt_basic"
              className="form-control input-sm"
              name="dt_basic_length"
              onChange={onPageSizeChange}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </label>
        </div>
      </div>
    </div>
  );
}

Toolbar.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  handleChangeTrainingProvider: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  trainingProviders: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default withNamespaces()(Toolbar);
